'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_EitherSample$package$Dog$1(name, age) {
  this.su = null;
  this.st = 0;
  this.su = name;
  this.st = age;
}
export { $c_Lsamples_EitherSample$package$Dog$1 as $c_Lsamples_EitherSample$package$Dog$1 };
$p = $c_Lsamples_EitherSample$package$Dog$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EitherSample$package$Dog$1;
/** @constructor */
function $h_Lsamples_EitherSample$package$Dog$1() {
}
export { $h_Lsamples_EitherSample$package$Dog$1 as $h_Lsamples_EitherSample$package$Dog$1 };
$h_Lsamples_EitherSample$package$Dog$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 68892);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.su));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.st);
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 2);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsamples_EitherSample$package$Dog$1) && ((this.st === x$0.st) && (this.su === x$0.su))));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 2;
});
$p.o = (function() {
  return "Dog";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.su;
  }
  if ((n === 1)) {
    return this.st;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lsamples_EitherSample$package$Dog$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eb)));
}
export { $isArrayOf_Lsamples_EitherSample$package$Dog$1 as $isArrayOf_Lsamples_EitherSample$package$Dog$1 };
var $d_Lsamples_EitherSample$package$Dog$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EitherSample$package$Dog$1, "samples.EitherSample$package$Dog$1", ({
  eb: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_EitherSample$package$Dog$1 as $d_Lsamples_EitherSample$package$Dog$1 };
